// extracted by mini-css-extract-plugin
export default {"root":"root--VgYxx","body2":"body2--P2wEj","seperator":"seperator--csqe6"};